import { render, staticRenderFns } from "./DamagedMissing.vue?vue&type=template&id=24ad842f&"
import script from "./DamagedMissing.ts?vue&type=script&lang=js&"
export * from "./DamagedMissing.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports